import { render } from "./ModalForms.vue?vue&type=template&id=30a8d138&scoped=true"
import script from "./ModalForms.vue?vue&type=script&lang=js"
export * from "./ModalForms.vue?vue&type=script&lang=js"

import "./ModalForms.vue?vue&type=style&index=0&id=30a8d138&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a8d138"]])

export default __exports__